import { render, staticRenderFns } from "./listSysNotice.vue?vue&type=template&id=f012580e&scoped=true&"
import script from "./listSysNotice.vue?vue&type=script&lang=js&"
export * from "./listSysNotice.vue?vue&type=script&lang=js&"
import style0 from "./listSysNotice.vue?vue&type=style&index=0&id=f012580e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f012580e",
  null
  
)

export default component.exports